export const LAST_LOGIN_ENTRY_KEY = 'crest_last_login_entry';

export type LoginEntryPath =
  | '/login'
  | '/platform'
  | '/crm'
  | '/agent'
  | '/operate'
  | '/crest'
  | '/erp';

export function normalizeLoginEntryPath(value: unknown): LoginEntryPath {
  if (
    value === '/platform' ||
    value === '/crm' ||
    value === '/agent' ||
    value === '/operate' ||
    value === '/crest' ||
    value === '/erp'
  ) {
    return value;
  }
  return '/login';
}

export function storedLoginEntryPath(storage?: Pick<Storage, 'getItem'>): LoginEntryPath {
  const value =
    storage?.getItem(LAST_LOGIN_ENTRY_KEY) ??
    (typeof localStorage === 'undefined' ? null : localStorage.getItem(LAST_LOGIN_ENTRY_KEY));
  return normalizeLoginEntryPath(value);
}

export function currentLoginEntryPath(location?: Pick<Location, 'pathname'>): LoginEntryPath {
  const pathname =
    location?.pathname ?? (typeof window === 'undefined' ? '/login' : window.location.pathname);
  if (pathname === '/crest') return '/crest';
  if (pathname === '/platform') return '/platform';
  if (pathname === '/crm') return '/crm';
  if (pathname === '/agent') return '/agent';
  if (pathname === '/operate') return '/operate';
  if (pathname === '/erp') return '/erp';
  return '/login';
}

export function isLoginEntryPathname(pathname: string): boolean {
  return (
    pathname.startsWith('/login') ||
    pathname === '/platform' ||
    pathname === '/crest' ||
    pathname === '/crm' ||
    pathname === '/agent' ||
    pathname === '/operate' ||
    pathname === '/erp'
  );
}
